import { Box, LinearProgress } from "@mui/material";
import styles from "./MainLoading.module.scss";
import logo from "../../assets/images/logo.png";
import React from "react";

const MainLoading: React.FC = () => {
  return (
    <Box className={styles.mainLoading}>
      <img src={logo} alt="Publication Workflows" />
      <div>
        <LinearProgress />
      </div>
    </Box>
  );
};

export default React.memo(MainLoading);
